<mat-card class="page-content" *appSkeletonLoader="{ loading: loading, amountOfRows: 4, height: '32px', minWidth:'20%', maxWidth: '90%', inMatCard: true}">
    <div fxLayout="column">
      <div class="mat-display-1 page-content-title div-spacer" style="margin-bottom: 10px;">Documentatie</div>
    </div>
    <markdown [data]="documentation" emoji ngPreserveWhitespaces></markdown>
</mat-card>